import {
  actions,
  getAllReaderHighlightsForContainerIdAsync,
  createNewHighlightAsync,
  deleteHighlightAsync,
} from './slices';

export const HighlightsActions = {
  ...actions,
  getAllReaderHighlightsForContainerIdAsync,
  createNewHighlightAsync,
  deleteHighlightAsync,
};
